import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import star from '../../assests/images/star.png'
import { Link } from 'react-router-dom'
function ClassComponent({ classDetails }) {
    console.log("==classDetails===", classDetails)
    const { t } = useTranslation()
    const [activeTab, setActiveTab] = useState("class");
    const handleTabChange = (tabId) => {

        setActiveTab(tabId);
    };
    return (
        <div className="col-md-5">
            <div className="ranking-box">
                <div className="joinings_viewBox_head">
                    <h5>{t("class")}</h5>
                </div>
                <ul
                    className="teamPerfomance_tab nav nav-tabs mb-3"
                    id="ex1"
                    role="tablist"
                >
                    <li className="nav-item" role="presentation" >
                        <Link
                            className={`nav-link ${activeTab === "class" ? "active" : ""}`}
                            id={`ex1-tab-${"class"}`}
                            data-bs-toggle="tab"
                            role="tab"
                            aria-controls={"class"}
                            aria-selected={activeTab === "class" ? "true" : "false"}
                            onClick={() => handleTabChange("class")}
                        >
                            {t("current_cls")}
                        </Link>
                    </li>
                    {
                        classDetails?.positionedUsers?.length > 0 &&
                        <li className="nav-item" role="presentation" >
                            <Link
                                className={`nav-link ${activeTab === "other-positions" ? "active" : ""
                                    }`}
                                id={`ex1-tab-${"other-positions"}`}
                                data-bs-toggle="tab"
                                role="tab"
                                aria-controls={"other-positions"}
                                aria-selected={activeTab === "other-positions" ? "true" : "false"}
                                onClick={() => handleTabChange("other-positions")}
                            >
                                {t("other-positions")}
                            </Link>
                        </li>
                    }

                </ul>
                <div className="tab-content" id="ex1-content">
                    {activeTab === "class" && (
                        <div
                            className={`tab-pane fade ${activeTab === "class" ? "show active" : ""}`}
                            id={"class"}
                            role="tabpanel"
                            aria-labelledby={"class"}
                        >
                            <div className="class_section text-center py-4">
                                {
                                    (classDetails?.className &&
                                        classDetails?.position) ?
                                        <>
                                            <h4 className="supervisor-title mb-3">{classDetails?.className}</h4>
                                            <h6 className="position-info">
                                                Position:
                                                <span className="position-circle">{classDetails?.position}</span>
                                            </h6>
                                        </>

                                        :
                                        <h4 className="supervisor-title mb-3">{t('no_active_cls')}</h4>

                                }

                            </div>
                        </div>
                    )}
                    {
                        activeTab === "other-positions" && (
                            <div
                                className={`tab-pane fade ${activeTab === "other-positions" ? "show active" : ""}`}
                                id={"other-positions"}
                                role="tabpanel"
                                aria-labelledby={"other-positions"}
                            >
                                <div className="">
                                    {
                                        classDetails?.positionedUsers?.map((item, index) => (
                                            <div key={index}>
                                                <div className="teammbrs_cnt_row">
                                                    <div className="teammbrs_cnt_img">
                                                        <img
                                                            src={
                                                                item.UserDetail.image
                                                                    ? item.UserDetail.image
                                                                    : "/images/user-profile.png"
                                                            }
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="teammbrs_cnt_name_dtl">
                                                        <div className="teammbrs_cnt_name" style={{ overflow: "hidden", textOverflow: "ellipsis", width: "125px" }}>
                                                            <span>{item.UserDetail.name} {item.UserDetail.secondName}</span><br />
                                                            <p style={{ color: '#909090' }}>{item.username}</p>
                                                        </div>
                                                    </div>
                                                    <div className="teamperfoamance_amount position-list">
                                                        {
                                                            item.classPosition === 1 ? <span>🥇</span> : item.classPosition === 2 ? <span>🥈</span> : <span>🥉</span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }


                                </div>
                            </div>

                        )
                    }




                </div>

            </div>
        </div>

    )
}

export default ClassComponent